/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

const tableLineConfiguration: {
    tableLineHeight: number;
    tableLinePaddingBottom: number;
} = {
    tableLineHeight: 48,
    tableLinePaddingBottom: 8
};

export default tableLineConfiguration;
